"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sum = exports.convert = exports.getSymbol = exports.SYMBOL_MAP = exports.getLabel = exports.LABEL_MAP_PLURAL = exports.LABEL_MAP_SINGULAR = exports.Time = exports.Day = exports.Hour = exports.Minute = exports.Second = exports.Millisecond = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Unit.Time';
exports.Millisecond = effect_1.Schema.TaggedStruct('Millisecond', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Millisecond` });
exports.Second = effect_1.Schema.TaggedStruct('Second', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Second` });
exports.Minute = effect_1.Schema.TaggedStruct('Minute', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Minute` });
exports.Hour = effect_1.Schema.TaggedStruct('Hour', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Hour` });
exports.Day = effect_1.Schema.TaggedStruct('Day', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Day` });
exports.Time = effect_1.Schema.Union(exports.Millisecond, exports.Second, exports.Minute, exports.Hour, exports.Day).annotations({
    identifier: `${exports.NAMESPACE}.Time`,
});
exports.LABEL_MAP_SINGULAR = {
    Millisecond: 'millisecond',
    Second: 'second',
    Minute: 'minute',
    Hour: 'hour',
    Day: 'day',
};
exports.LABEL_MAP_PLURAL = {
    Millisecond: 'milliseconds',
    Second: 'seconds',
    Minute: 'minutes',
    Hour: 'hours',
    Day: 'days',
};
/**
 * Retrieves the label corresponding to a given {@link Time}-tag
 */
const getLabel = (time) => time.amount === 1 ? exports.LABEL_MAP_SINGULAR[time._tag] : exports.LABEL_MAP_PLURAL[time._tag];
exports.getLabel = getLabel;
exports.SYMBOL_MAP = {
    Millisecond: 'ms',
    Second: 's',
    Minute: 'min',
    Hour: 'h',
    Day: 'd',
};
/**
 * Retrieves the symbol corresponding to a given {@link Time}-tag
 */
const getSymbol = (tag) => exports.SYMBOL_MAP[tag];
exports.getSymbol = getSymbol;
/**
 * Ratio between {@link Millisecond} and other {@link Time} unit of measure
 */
const FACTOR_MAP = {
    Millisecond: 1,
    Second: 1_000,
    Minute: 60 * 1_000,
    Hour: 60 * 60 * 1_000,
    Day: 24 * 60 * 60 * 1_000,
};
/**
 * Converts any {@link Time} measure to a specific time measure
 */
exports.convert = effect_1.Function.dual(2, (time, outTag) => {
    const ms = time.amount * FACTOR_MAP[time._tag];
    return {
        _tag: outTag,
        amount: ms / FACTOR_MAP[outTag],
    };
});
/**
 * Sums {@link Time} quantities and returns the result in the unit of measure of the 0th parameter
 */
const sum = (time, ...args) => effect_1.Array.reduce(args, time, (acc, time) => ({
    ...acc,
    amount: acc.amount + (0, exports.convert)(time, acc._tag).amount,
}));
exports.sum = sum;
//# sourceMappingURL=time.js.map